<template>
  <div>
    <checkbox-item
      v-for="(item, index) in selectionList"
      :id="Array.isArray(item) ? item[0] : null"
      ref="multiCheckbox"
      :key="index"
      :title="Array.isArray(item) ? item[1] : item"
      :default-checked="isDefaultCheckedId(item)"
      :disabled="isUpperLimit"
      :read-only="readOnly"
      class="d-inline-block col-6 pl-0 pr-sm-3 mb-3 col-sm-auto align-middle"
      :class="( index % 2 ) == 0 ? 'pr-3' : 'pr-0'"
      :form-name="formName"
      @change="changeSelectList"
    />
  </div>
</template>

<script>
import CheckboxItem from "./CheckboxItem.vue";

export default {
  components: { CheckboxItem },
  props: {
    selectionList: {
      type: Array,
      default: () => ([])
    },
    defaultCheckedIds: {
      type: Array,
      default: () => ([])
    },
    defaultCheckedNames: {
      type: Array,
      default: () => ([])
    },
    limitCount: {
      type: Number,
      default: null
    },
    formName: {
      type: String,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectIds: []
    };
  },
  computed: {
    isUpperLimit() {
      if (this.limitCount === null) {
        return false;
      }
      return this.selectIds.length >= this.limitCount;
    }
  },
  methods: {
    isDefaultCheckedId(item) {
      if (Array.isArray(item)) {
        if (this.defaultCheckedIds === null) {
          return false;
        }
        return this.defaultCheckedIds.includes(item[0]);
      }
      return this.defaultCheckedNames.includes(item);
    },
    unchecked(id) {
      const checkboxList = this.$refs.multiCheckbox;

      checkboxList.forEach(element => {
        if (element.id === id) {
          element.changeCheckboxStatus(false);
        }
      });
    },
    checked(ids) {
      const checkboxList = this.$refs.multiCheckbox;

      checkboxList.forEach(element => {
        element.changeCheckboxStatus(false);
        if (ids.includes(element.id)) {
          element.changeCheckboxStatus(true);
        }
      });
    },
    changeSelectList(item, checked) {
      if (checked === true) {
        this.selectIds.push(item);
      } else {
        this.selectIds = this.selectIds.filter(n => n !== item);
      }
      this.$emit("change", this.selectIds);
    }
  }
};
</script>
